import { InDirectionComponent } from "./In";
import { OutDirectionComponent } from "./Out";

export function DirectionBadgeComponent() {
  return <></>;
}

DirectionBadgeComponent.In = InDirectionComponent;
DirectionBadgeComponent.Out = OutDirectionComponent;
